import { cn } from '@landler/component-library';
import { TextInput, TextInputProps } from 'component-library/Input/TextInput';

import { FormControl, FormDescription, FormItem, FormLabel, FormMessage, useFormField } from '@/components/Form';

import { useControlsContext } from './Form';

type FormTextInputProps = {
  formName: string;
  label?: string;
  helper?: string;
} & TextInputProps;

export const FormTextInput = ({ formName, label, helper, ...props }: FormTextInputProps) => {
  const { setValue, watch } = useControlsContext();
  const { error } = useFormField();

  const selectedFormValue = watch(formName);

  const handleValueChange = (value: string | null) => {
    setValue(formName, value);
  };

  return (
    <FormItem className='flex flex-col gap-1 w-full'>
      <FormLabel
        className={cn('text-[.75rem] font-medium leading-4 text-text-secondary md:text-[.8125rem] md:leading-5', {
          'text-error': error,
        })}
      >
        {label ?? ''}
      </FormLabel>
      <FormControl>
        <TextInput {...props} value={selectedFormValue} onChange={(e) => handleValueChange(e.target.value)} />
      </FormControl>
      <FormMessage className='typography-inputLabel mt-0 text-error'>{error?.message ?? ''}</FormMessage>
      <FormDescription>{helper ?? ''}</FormDescription>
    </FormItem>
  );
};
